import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import { useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import AnswerDropDown from "../component/AnswerDropDown";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";
import useForm from "../../../../hooks/useForm";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import URLS from "../../../../API/Axios/URLS";



function MapQuestion({question, answer, setAnswer, showAnswer, transcript}) {

    function handleSelect(e, wordIndex) {
        let value = e.target.value
        let newAnswer = [...answer]
        if (answer.length === 0) {
            //     make an empty array of length of the options
            newAnswer = new Array(question?.choices.length).fill("")

        }
        newAnswer[wordIndex] = value
        setAnswer(newAnswer)
    }

    let mt = 'mt-1'
    return question?.text?.split(" ").map((word, wordIndex) => {
            if (word.includes("<b>")) {
                let index = word.replace("<b>", "").replace("</b>", "")
                return <select
                    onChange={(e) => handleSelect(e, index - 1)}
                    className={`border text-xl rounded active:border focus:border px-3 p-1 
                ${showAnswer && question?.choices[index - 1]?.correct === answer[index - 1] ? "border-green-400" : ""}
                ${showAnswer && question?.choices[index - 1]?.correct !== answer[index - 1] && answer[index - 1] !== "" ? "border-red-400" : ""}
                
                `}>
                    <option value={""}></option>
                    {question?.choices[index - 1]?.options?.map((option) => {
                        return <option value={option}>{option}</option>
                    })}
                </select>


            } else {
                return <span className={mt+" text-xl"} key={wordIndex}>{word} </span>
            }
        }
    )
}

export default function CompleteTheSentences({className, ...props}) {
    const {id} = useParams()
    const [response, setResponse] = useState(null)
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: [],
    })
    useEffect(() => {

        questionActions.loadQuestions(id)
    }, []);

    function removeEmpty(arr) {
        return arr.filter((item) => item !== "")
    }
    function submitAnswer() {
        if (removeEmpty(form?.answer).length !== question?.choices.length) {
            actions.setError({
                non_field_errors: ["Please select all the option"]
            })
            return
        }
        actions.post(URLS.genericQuestionView, (data) => {
            return {
                ...data,
                answer: form?.answer.join(",")
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
        })


    }

    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 10000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>

                <div className={"flex flex-1 px-8 flex-col gap-4"}>

                    <div className={"font-semibold gap-2 flex items-center align-middle flex-wrap"}>
                        <MapQuestion
                            question={question}
                            showAnswer={!!response}
                            transcript={question?.transcript}
                            setAnswer={(ans) => {
                                console.log(ans)
                                setFormData({answer: ans})
                            }}
                            answer={form?.answer}
                        />
                    </div>
                    <FormNoneFieldErrors className={"mt-3"}
                                         errors={error?.answer || error?.non_field_errors || error?.time}/>
                </div>


            </div>
            <QuestionFooter
                loading={loading}
                disabled={!!response}
                onClickSubmit={submitAnswer}
                className={"mx-4 my-2"}/>

            <AnswerDropDown
                headerTitle={"Answer"}
                justifications={
                    question?.explanation?.split("\n").map((line, index) => {
                        return <p key={index}>{line}</p>
                    })
                }
            />

        </div>

    )
}
